import merge from 'lodash/merge';
import parseClickUrl from './commonParsers/clickUrlParser';
import makeImageUrlSecure from './commonParsers/makeImageUrlSecure';
import parseRebate from './commonParsers/rebateParser';

export default (response, state, action) =>
  response.map(product =>
    merge(product, {
      clickUrl: parseClickUrl(product.clickUrl, state, action),
      images: product.images.map(makeImageUrlSecure),
      mainImage: makeImageUrlSecure(product.images[0]),
      rebate: parseRebate(product.rebate, product.tiers, state),
    }));
